/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SkillFeedbackPayload,
  SkillFeedbackPayload$Outbound,
  SkillFeedbackPayload$outboundSchema,
} from "../components/skillfeedbackpayload.js";

export type SkillFeedbackSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  projectSlugHeaderGramProject?: string | undefined;
};

export type SkillFeedbackRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  skillFeedbackPayload: SkillFeedbackPayload;
};

/** @internal */
export type SkillFeedbackSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "project_slug_header_Gram-Project"?: string | undefined;
};

/** @internal */
export const SkillFeedbackSecurity$outboundSchema: z.ZodMiniType<
  SkillFeedbackSecurity$Outbound,
  SkillFeedbackSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    projectSlugHeaderGramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function skillFeedbackSecurityToJSON(
  skillFeedbackSecurity: SkillFeedbackSecurity,
): string {
  return JSON.stringify(
    SkillFeedbackSecurity$outboundSchema.parse(skillFeedbackSecurity),
  );
}

/** @internal */
export type SkillFeedbackRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  SkillFeedbackPayload: SkillFeedbackPayload$Outbound;
};

/** @internal */
export const SkillFeedbackRequest$outboundSchema: z.ZodMiniType<
  SkillFeedbackRequest$Outbound,
  SkillFeedbackRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    skillFeedbackPayload: SkillFeedbackPayload$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      skillFeedbackPayload: "SkillFeedbackPayload",
    });
  }),
);

export function skillFeedbackRequestToJSON(
  skillFeedbackRequest: SkillFeedbackRequest,
): string {
  return JSON.stringify(
    SkillFeedbackRequest$outboundSchema.parse(skillFeedbackRequest),
  );
}
